<template>
  <section class="my-orders" aria-labelledby="my-orders-heading">
    <header>
      <button type="button" @click="$emit('setIsChangePage', 'product')">До магазину</button>
      <h1 id="my-orders-heading">Мої замовлення</h1>
      <button type="button" :disabled="loading" @click="refresh">Оновити</button>
    </header>
    <button v-if="selectedId" type="button" class="back-to-orders" @click="loadPage(page)">До списку замовлень</button>
    <p v-if="loading" role="status">Завантаження замовлень…</p>
    <div v-else-if="error" role="alert">
      <p>{{ error }}</p><button type="button" @click="refresh">Спробувати ще раз</button>
    </div>
    <order-history-details v-else-if="detail" ref="details" :order="detail" />
    <template v-else>
      <h2 ref="listHeading" tabindex="-1" class="list-heading">Історія замовлень</h2>
      <p v-if="!orders.length">{{ meta.total ? 'На цій сторінці немає замовлень.' : 'У вас ще немає замовлень.' }}</p>
      <button v-if="!orders.length && page > 1" type="button" @click="loadPage(1)">На першу сторінку</button>
      <ol class="order-list">
        <li v-for="order in orders" :key="order.id">
          <button type="button" class="order-card" @click="openOrder(order.id)">
            <strong>Замовлення №{{ order.id }}</strong><span>{{ orderDate(order.date) }}</span>
            <span>Статус замовлення: {{ orderStatus(order.status) }}</span>
            <span>Оплата: {{ orderPayment(order.payment_status) }}</span>
            <span>Сума замовлення: {{ orderPoints(order.total) }}</span>
            <span>Деталі замовлення →</span>
          </button>
        </li>
      </ol>
      <nav v-if="meta.total" class="order-pagination" aria-label="Сторінки моїх замовлень">
        <button type="button" :disabled="page <= 1" @click="loadPage(page - 1)">Попередня</button>
        <span>Сторінка {{ page }} з {{ meta.last_page }}</span>
        <button type="button" :disabled="page >= meta.last_page" @click="loadPage(page + 1)">Наступна</button>
      </nav>
    </template>
  </section>
</template>
<script>
import OrderHistoryDetails from "../../../components/OrderHistoryDetails.vue";
import { GET_MY_ORDERS, GET_MY_ORDER } from "../helpers/requests";
import { ordersPage, orderDetail, historyLocation, orderDate, orderStatus, orderPayment, orderPoints } from "../helpers/orderHistory";

export default {
  components: { OrderHistoryDetails },
  data() {
    const location = historyLocation(window.location.hash);
    return { page: location.page, selectedId: location.order, orders: [], detail: null,
      meta: { total: 0, last_page: 1 }, loading: false, error: null, requestVersion: 0 };
  },
  mounted() {
    window.addEventListener("hashchange", this.onLocationChange);
    this.onLocationChange();
  },
  beforeDestroy() { this.requestVersion++; window.removeEventListener("hashchange", this.onLocationChange); },
  methods: {
    orderDate, orderStatus, orderPayment, orderPoints,
    onLocationChange() {
      if (!/^#orders(?:\?|$)/.test(window.location.hash)) return;
      const location = historyLocation(window.location.hash);
      this.page = location.page;
      return location.order ? this.openOrder(location.order) : this.loadPage(location.page);
    },
    remember(order) {
      const params = new URLSearchParams({ page: String(this.page) });
      if (order) params.set("order", String(order));
      window.history.replaceState(null, "", `${window.location.pathname}${window.location.search}#orders?${params}`);
    },
    refresh() { this.selectedId ? this.openOrder(this.selectedId) : this.loadPage(this.page); },
    async loadPage(page) {
      const version = ++this.requestVersion;
      this.page = page; this.selectedId = null; this.detail = null; this.orders = [];
      this.loading = true; this.error = null; this.remember();
      try {
        const result = ordersPage(await GET_MY_ORDERS(page));
        if (version !== this.requestVersion) return;
        this.orders = result.data; this.meta = result.meta; this.page = result.meta.current_page;
        this.$nextTick(() => { if (version === this.requestVersion) this.$refs.listHeading?.focus(); });
      } catch (error) {
        if (version === this.requestVersion) this.error = "Не вдалося завантажити замовлення. Спробуйте ще раз.";
      } finally { if (version === this.requestVersion) this.loading = false; }
    },
    async openOrder(id) {
      const version = ++this.requestVersion;
      this.selectedId = String(id); this.detail = null; this.loading = true; this.error = null; this.remember(id);
      try {
        const order = orderDetail(await GET_MY_ORDER(id), id);
        if (version !== this.requestVersion) return;
        this.detail = order;
        this.$nextTick(() => { if (version === this.requestVersion) this.$refs.details?.focusTitle(); });
      } catch (error) {
        if (version === this.requestVersion) this.error = error.status === 404
          ? "Замовлення не знайдено або недоступне." : "Не вдалося завантажити деталі замовлення. Спробуйте ще раз.";
      } finally { if (version === this.requestVersion) this.loading = false; }
    },
  },
};
</script>
<style scoped>
.my-orders { max-width: 960px; margin: 0 auto; padding: 16px 16px 120px; color: #292929; overflow-wrap: anywhere; }
header { display: flex; flex-wrap: wrap; align-items: center; gap: 12px; margin-bottom: 24px; }
h1 { flex: 1 1 100%; font-size: 24px; order: -1; } .list-heading { font-size: 18px; margin: 16px 0; }
button { font: inherit; padding: 12px; min-height: 44px; cursor: pointer; border: 1px solid #b4cde3; border-radius: 8px; color: #155d9b; background: #fff; }
button:focus-visible { outline: 2px solid #155d9b; outline-offset: 2px; }
button:disabled { color: #777; cursor: default; border-color: #ddd; }
.back-to-orders { margin-bottom: 16px; }
.order-list { list-style: none; padding: 0; display: grid; gap: 16px; }
.order-card { width: 100%; display: grid; gap: 8px; text-align: left; color: #292929; }
.order-card span:last-child { color: #155d9b; }
.order-pagination { display: flex; flex-wrap: wrap; align-items: center; justify-content: center; gap: 12px; margin-top: 24px; }
</style>
